export default __webpack_public_path__ + "static/media/ERI_Brochure_1.df5c4ece.jpg";